import { PHONE_DISPLAY, PHONE_HREF, WHATSAPP_HREF } from './contact';

export const siteOrigin = 'https://abschleppdienst-schiek.de';
export const brandName = 'Abschleppdienst Schiek';

export { PHONE_DISPLAY, PHONE_HREF, WHATSAPP_HREF };

export type ServicePage = {
  slug: string;
  title: string;
  shortTitle: string;
  eyebrow: string;
  metaTitle: string;
  metaDescription: string;
  summary: string;
  intro: string;
  bullets: string[];
  steps: string[];
  needed: string[];
  faq: Array<{ question: string; answer: string }>;
};

export const servicePages: ServicePage[] = [
  {
    slug: 'pannenhilfe-berlin',
    title: 'Pannenhilfe Berlin 24/7',
    shortTitle: 'Pannenhilfe',
    eyebrow: 'Panne in Berlin',
    metaTitle: 'Pannenhilfe Berlin 24h | Abschleppdienst Schiek',
    metaDescription:
      'Pannenhilfe in Berlin rund um die Uhr: Hilfe bei Liegenbleibern, Startproblemen und Abschleppen zur Werkstatt. Direkt Schiek anrufen.',
    summary:
      'Wenn Ihr Fahrzeug nicht mehr weiterkommt, klären wir die Situation direkt und bringen entweder Hilfe vor Ort oder schleppen sicher ab.',
    intro:
      'Nicht jede Panne endet mit einem Abschleppvorgang. Wir prüfen zuerst, ob eine sichere Hilfe vor Ort realistisch möglich ist. Wenn nicht, transportieren wir Ihr Fahrzeug zur Werkstatt, nach Hause oder an einen abgestimmten Zielort.',
    bullets: [
      'Fahrzeug startet nicht oder bleibt unterwegs liegen.',
      'Batterie leer, Reifenproblem oder technische Warnung.',
      'Abtransport zur Werkstatt oder Wunschadresse in Berlin.',
    ],
    steps: [
      'Standort und Fahrzeugtyp telefonisch durchgeben.',
      'Situation kurz beschreiben: Startproblem, Reifen, Warnleuchte oder Liegenbleiber.',
      'Wir prüfen, ob Hilfe vor Ort reicht oder abgeschleppt werden muss.',
      'Fahrzeug wird sicher aufgenommen und zum Ziel gebracht.',
    ],
    needed: ['Genauer Standort', 'Fahrzeugmodell', 'Schadenbild', 'gewünschtes Ziel, falls bekannt'],
    faq: [
      {
        question: 'Kann Schiek auch helfen, wenn das Fahrzeug nur nicht startet?',
        answer:
          'Ja. Wenn eine sichere Hilfe vor Ort möglich ist, prüfen wir das direkt. Falls nicht, wird das Fahrzeug zuverlässig transportiert.',
      },
      {
        question: 'Ist Pannenhilfe nachts möglich?',
        answer:
          'Ja, Schiek ist für akute Fälle rund um die Uhr erreichbar. Am Telefon bekommen Sie eine realistische Einschätzung.',
      },
    ],
  },
  {
    slug: 'unfallbergung-berlin',
    title: 'Unfallbergung Berlin',
    shortTitle: 'Unfallbergung',
    eyebrow: 'Nach Unfall',
    metaTitle: 'Unfallbergung Berlin | Abschleppdienst Schiek',
    metaDescription:
      'Unfallbergung und Fahrzeugtransport in Berlin. Schiek hilft beim sicheren Abtransport nach Unfall oder Schaden.',
    summary:
      'Nach einem Unfall zählt ein ruhiger Ablauf: Erst Sicherheit, dann Bergung und Abtransport mit klarer Abstimmung.',
    intro:
      'Nach einem Unfall sichern Sie sich und andere zuerst ab. Bei Verletzten oder Gefahrenstellen müssen Polizei oder Rettungsdienst gerufen werden. Danach unterstützt Schiek bei Bergung und Fahrzeugtransport.',
    bullets: [
      'Abtransport fahruntüchtiger Fahrzeuge nach Kollision oder Schaden.',
      'Abstimmung von Zielort, Werkstatt oder Abstellort.',
      'Sachlicher Ablauf ohne Panikmache oder unrealistische Versprechen.',
    ],
    steps: [
      'Sicherheit herstellen und bei Bedarf Polizei/Rettungsdienst alarmieren.',
      'Schiek mit Standort, Fahrzeug und Schaden kontaktieren.',
      'Bergung und Transportweg abstimmen.',
      'Fahrzeug sicher verladen und zum Ziel transportieren.',
    ],
    needed: ['Standort', 'Fahrzeugtyp', 'Unfallsituation', 'Transportziel', 'ob Polizei/Rettung vor Ort ist'],
    faq: [
      {
        question: 'Soll ich nach einem Unfall zuerst Schiek oder die Polizei rufen?',
        answer:
          'Bei Verletzten, Gefahr oder unklarer Lage zuerst Polizei beziehungsweise Rettungsdienst. Danach können Sie Schiek für Bergung und Transport kontaktieren.',
      },
      {
        question: 'Kann das Fahrzeug direkt zur Werkstatt?',
        answer: 'Ja, wenn ein Ziel bekannt ist, kann der Transport direkt zur gewünschten Werkstatt erfolgen.',
      },
    ],
  },
  {
    slug: 'falschparker-abschleppen-berlin',
    title: 'Falschparker abschleppen Berlin',
    shortTitle: 'Falschparker',
    eyebrow: 'Privatgrund & Einfahrt',
    metaTitle: 'Falschparker abschleppen Berlin | Privatgrund & Einfahrt',
    metaDescription:
      'Falschparker auf Privatparkplatz, Einfahrt oder Hof in Berlin? Abschleppdienst Schiek hilft mit Dokumentation und direkter Abwicklung.',
    summary:
      'Für blockierte Einfahrten, Höfe und Privatparkplätze unterstützt Schiek bei berechtigten Abschleppfällen mit sauberer Dokumentation.',
    intro:
      'Wenn ein Fahrzeug unberechtigt auf Privatgrund steht, muss der Fall sauber geklärt und dokumentiert werden. Schiek unterstützt Eigentümer, Hausverwaltungen und Gewerbebetriebe bei der direkten Abwicklung.',
    bullets: [
      'Blockierte Einfahrt, Hof, Kundenparkplatz oder Privatstellplatz.',
      'Dokumentation des Falls vor Ort.',
      'Direkte Abstimmung mit Berechtigten, nicht über öffentliche Behörden.',
    ],
    steps: [
      'Berechtigung und Standort telefonisch klären.',
      'Situation mit Fotos und Angaben dokumentieren.',
      'Abschleppvorgang abstimmen.',
      'Fahrzeug wird nach geklaerter Beauftragung und Dokumentation entfernt.',
    ],
    needed: ['Adresse', 'Art des Privatgrundstücks', 'Kennzeichen/Fahrzeug', 'Fotos der Situation', 'Ihre Berechtigung'],
    faq: [
      {
        question: 'Schleppt Schiek auch aus dem öffentlichen Straßenraum ab?',
        answer:
          'Öffentlicher Straßenraum ist Sache von Ordnungsamt und Polizei. Schiek hilft bei Privatgrund, Einfahrten, Höfen und privaten Parkflächen.',
      },
      {
        question: 'Brauche ich Fotos?',
        answer:
          'Fotos helfen bei der Dokumentation. Am Telefon klären wir, welche Informationen im konkreten Fall wichtig sind.',
      },
    ],
  },
  {
    slug: 'auto-abschleppen-lassen-berlin',
    title: 'Auto abschleppen lassen Berlin',
    shortTitle: 'Auto abschleppen',
    eyebrow: 'Transport zur Werkstatt',
    metaTitle: 'Auto abschleppen lassen Berlin | Schiek 24h',
    metaDescription:
      'Auto in Berlin abschleppen lassen: Schiek transportiert Ihr Fahrzeug sicher zur Werkstatt, nach Hause oder zum Wunschziel.',
    summary:
      'Wenn das Auto nicht fahrbereit ist, organisiert Schiek den sicheren Transport zum gewünschten Ziel in Berlin und Umgebung.',
    intro:
      'Ob Panne, Schaden oder planbarer Transport: Wir klären Start, Ziel und Fahrzeugtyp und geben Ihnen eine klare Rückmeldung zum Ablauf.',
    bullets: [
      'Transport zur Werkstatt, nach Hause oder zum Abstellort.',
      'Planbare Fahrzeugtransporte nach Absprache.',
      'Direkte Kommunikation ohne Vermittlungsplattform.',
    ],
    steps: [
      'Start- und Zieladresse nennen.',
      'Fahrzeugtyp und Zustand beschreiben.',
      'Zeitfenster und Ablauf abstimmen.',
      'Fahrzeug wird sorgfältig aufgenommen und transportiert.',
    ],
    needed: ['Startadresse', 'Zieladresse', 'Fahrzeugtyp', 'fahrbereit oder nicht fahrbereit'],
    faq: [
      {
        question: 'Kann ich den Transport planen?',
        answer: 'Ja. Für planbare Transporte nennen Sie Start, Ziel, Fahrzeugtyp und gewünschten Zeitraum.',
      },
      {
        question: 'Transportiert Schiek auch zur Prüfstelle oder zum Händler?',
        answer: 'Ja, planbare Transporte zu Werkstatt, Händler, Prüfstelle oder Privatadresse sind nach Absprache möglich.',
      },
    ],
  },
  {
    slug: 'tiefgarage-abschleppen-berlin',
    title: 'Tiefgarage & Hof abschleppen Berlin',
    shortTitle: 'Tiefgarage & Hof',
    eyebrow: 'Enge Zufahrten',
    metaTitle: 'Tiefgarage abschleppen Berlin | Hof & enge Zufahrt',
    metaDescription:
      'Abschleppen aus Tiefgarage, Hof oder enger Zufahrt in Berlin. Schiek prüft Höhe, Zugang und Fahrzeug vor dem Einsatz.',
    summary:
      'Bei engen Höfen und Tiefgaragen muss der Einsatz sauber geplant werden. Schiek klärt Höhe, Zufahrt und Fahrzeugdaten vorab.',
    intro:
      'Nicht jede Tiefgarage ist mit jedem Fahrzeug erreichbar. Deshalb prüfen wir vorab die wichtigsten Daten und sagen offen, ob der Einsatz sinnvoll möglich ist.',
    bullets: ['Tiefgaragen, Hinterhöfe, enge Zufahrten.', 'Vorabklärung von Höhe und Rangierfläche.', 'Geeignete Lösung statt improvisiertem Einsatz.'],
    steps: ['Höhe/Zufahrt nennen.', 'Fahrzeugstandort beschreiben.', 'Fotos oder Skizze senden, wenn möglich.', 'Einsatz realistisch abstimmen.'],
    needed: ['Durchfahrtshöhe', 'Standort in der Garage', 'Fahrzeugtyp', 'Fotos der Zufahrt'],
    faq: [
      {
        question: 'Kann jedes Fahrzeug aus einer Tiefgarage abgeschleppt werden?',
        answer: 'Nein, das hängt von Höhe, Zufahrt und Fahrzeug ab. Wir prüfen den Fall vorab ehrlich.',
      },
    ],
  },
  {
    slug: 'motorrad-abschleppen-berlin',
    title: 'Motorrad abschleppen Berlin',
    shortTitle: 'Motorrad & Roller',
    eyebrow: 'Zweiradtransport',
    metaTitle: 'Motorrad abschleppen Berlin | Roller & Zweiradtransport',
    metaDescription:
      'Motorrad oder Roller in Berlin abschleppen lassen. Schiek transportiert Zweiräder nach Panne, Unfall oder Schaden.',
    summary:
      'Motorräder und Roller brauchen sichere Aufnahme und ruhigen Transport. Schiek übernimmt Zweiradtransporte nach Absprache.',
    intro:
      'Nach Panne oder Unfall transportieren wir Motorräder und Roller sorgfältig zum gewünschten Ziel. Am Telefon klären wir Modell, Standort und Zustand.',
    bullets: ['Transport nach Panne oder Unfall.', 'Roller, Motorrad und kleinere Fahrzeuge nach Absprache.', 'Sorgfältige Aufnahme statt improvisierter Lösung.'],
    steps: ['Standort und Fahrzeug nennen.', 'Schaden oder Panne beschreiben.', 'Zieladresse abstimmen.', 'Transport durchführen.'],
    needed: ['Standort', 'Motorrad-/Rollermodell', 'Schadenbild', 'Zieladresse'],
    faq: [
      {
        question: 'Transportiert Schiek auch Roller?',
        answer: 'Ja, Roller und Motorräder sind nach Absprache möglich.',
      },
    ],
  },
];

export const areaClusters = [
  'Mitte',
  'Friedrichshain-Kreuzberg',
  'Neukölln',
  'Charlottenburg-Wilmersdorf',
  'Spandau',
  'Pankow',
  'Reinickendorf',
  'Lichtenberg',
  'Tempelhof-Schöneberg',
  'Steglitz-Zehlendorf',
  'Treptow-Köpenick',
  'Marzahn-Hellersdorf',
  'Berliner Umland nach Absprache',
];

export const faqItems = [
  {
    question: 'Was kostet das Abschleppen?',
    answer:
      'Die Kosten hängen von Einsatzort, Fahrzeug, Aufwand und Zielort ab. Am Telefon nennen wir die relevanten Faktoren transparent.',
  },
  {
    question: 'Ist Schiek rund um die Uhr erreichbar?',
    answer: 'Ja, für akute Fälle ist Schiek 24/7 erreichbar, auch nachts, am Wochenende und an Feiertagen.',
  },
  {
    question: 'Hilft Schiek auch bei Falschparkern?',
    answer:
      'Ja, bei berechtigten Abschleppfällen auf Privatgrund, Einfahrten, Höfen und privaten Parkflächen. Öffentlicher Straßenraum ist Sache der Behörden.',
  },
  {
    question: 'Rechnet Schiek über Automobilclubs ab?',
    answer:
      'Nein. Schiek ist ein privater Abschleppdienst. Sie beauftragen uns direkt; Clubkarten und Gutscheinsysteme werden nicht direkt abgerechnet.',
  },
];

export function getServicePage(slug: string | undefined) {
  return servicePages.find((service) => service.slug === slug);
}
